export default __webpack_public_path__ + "static/media/LR Logo_N_BG.a8abf056.svg";